export default __webpack_public_path__ + "static/media/Archer-Medium.67e2e1ab.svg";